// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

export const User = {
  EXTERNAL_USER_ID: "a7449b1b-469a-4ab7-929a-af7b941c839f",
};
